import Input from "@hudson/ui/components/FormFields/Input";
import Field from "@hudson/ui/components/FormFields/Field";

function ValidationValue({
  errorFormatMessage,
  errorMessage,
  fieldName,
  label,
  requiredPlaceholder,
  validationType,
}: {
  errorFormatMessage: string;
  errorMessage: string;
  fieldName: string;
  label: string;
  requiredPlaceholder?: string;
  validationType: string;
}): JSX.Element | null {
  let autocomplete: string | undefined,
    fieldValidationPattern = {};
  if (validationType == "email") {
    autocomplete = "email";
    fieldValidationPattern = {
      value: /^\s*([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})\s*$/i,
      message: errorFormatMessage,
    };
  } else if (validationType == "phone") {
    autocomplete = "tel";
  }

  return (
    <Field
      errorMessage={errorMessage}
      fieldControl={(value, onChange, inError, onBlur) => (
        <Input
          autoComplete={autocomplete}
          className="w-60"
          inError={inError}
          onBlur={onBlur}
          onChange={onChange}
          required={Boolean(errorMessage)}
          requiredPlaceholder={requiredPlaceholder}
          value={value}
        />
      )}
      fieldName={fieldName}
      fieldValidations={{ required: errorMessage, pattern: fieldValidationPattern }}
      label={label}
    />
  );
}

export default ValidationValue;
